import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setStatus('success');
      setEmail('');
    }
  };
  return <section className="py-32 px-6 relative overflow-hidden" data-id="element-12">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] to-[#111]" data-id="element-13" />
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-14" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-15">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-7xl font-bold mb-8 tracking-tight" data-id="element-16">
          Ready to transform
          <br data-id="element-17" />
          your workflow?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-[#a3a3a3] mb-12 max-w-2xl mx-auto" data-id="element-18">
          Join 10,000+ designers creating stunning mockups in seconds. No credit
          card required.
        </motion.p>

        {status === 'success' ? <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="flex items-center justify-center gap-2 text-[#ff6b35] bg-[#ff6b35]/10 py-4 px-6 rounded-full inline-flex border border-[#ff6b35]/20" data-id="element-19">
            <CheckCircle2 className="w-5 h-5" data-id="element-20" />
            <span className="font-medium" data-id="element-21">
              You're on the list! We'll be in touch soon.
            </span>
          </motion.div> : <motion.form onSubmit={handleSubmit} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto" data-id="element-22">
            <input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} required className="flex-1 bg-[#1a1a1a] border border-[#333] rounded-full px-6 py-3 text-white focus:border-[#ff6b35] focus:outline-none transition-colors" data-id="element-23" />
            <Button type="submit" withArrow data-id="element-24">
              Get Early Access
            </Button>
          </motion.form>}
      </div>
    </section>;
}